import Mailto from "../../Components/Mailto";
import Error from "../../Layouts/Error";
import InnerHeader from "../../Layouts/InnerHeader";
import Loading from "../../Layouts/Loading";
import { useGetClientsQuery } from "../../Redux/Apis/shopApi";
import { fa_date, fa_number } from "../../utils/Persian";

export default function Client(){
    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error,
    } = useGetClientsQuery({})
    
    if(isLoading)
        return <Loading/>

    else if(isError)
        return <Error data={error}/>

    else if(isSuccess)
        return(
            <div className="container-lg">
                <InnerHeader name="مشتریان"/>
                <div className="row">
                    {data && data.length > 0 ? <table className="table">
                        <thead>
                            <tr>
                            <th scope="col">#</th>
                            <th scope="col">نام</th>
                            <th scope="col">نام خانوادگی</th>
                            <th scope="col">شماره موبایل</th>
                            <th scope="col">تاریخ عضویت</th>
                            <th scope="col">اقدامات</th>
                            </tr>
                        </thead>
                        <tbody>
                        {data.map((value:any,index:number) => 
                            <tr key={index}>
                                <th scope="row">{fa_number(index + 1)}</th>
                                <td>{value.name}</td>
                                <td>{value.family}</td>
                                <td>{value.mobile}</td>
                                <td>{fa_date(value.create_date)}</td>
                                <td>
                                    {value.mobile && <Mailto label={`تماس`} action={`tel:${value.mobile}`} />}
                                    {value.mobile && <Mailto label={`ارسال پیامک`} action={`sms:${value.mobile}`} />}
                                </td>
                            </tr>
                            )}
                        </tbody>
                    </table> 
                    :
                    <div className="alert d-flex align-items-center" role="alert">
                        <i className="zmdi zmdi-info"></i>
                        <div className="ms-2">
                         مشتری یافت نشد
                        </div>
                    </div>
                    }
                </div>
            </div>
        )

    else return <></>
}